import { render, staticRenderFns } from "./CusCertification.vue?vue&type=template&id=6db0188b&scoped=true"
import script from "./CusCertification.vue?vue&type=script&lang=js"
export * from "./CusCertification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db0188b",
  null
  
)

export default component.exports